export const set = (key, value) => {
	localStorage.setItem(key, JSON.stringify(value))
}

export const get = (key) => {
	const value = localStorage.getItem(key)
	return value ? JSON.parse(value) : null
}

export const unset = (...keys) => {
	keys.forEach(key => {
		localStorage.removeItem(key)
	})
}


// WEBPACK FOOTER //
// ./src/storage.js